import mixpanel from "mixpanel-browser";
import { miniAppBridgeService } from "@/api/services/miniapp-bridge-service";

/**
 * Hangi istemciden geldiğimiz: `web` ya da mini-app içindeysek `iscep`.
 *
 * Backend'in `x-source` header'ı ve Mixpanel'in `source` property'si için TEK
 * kaynak. Daha önce bu ifade altı ayrı yerde kopyalanmıştı (api-client
 * interceptor'ı, üç fetch çağrısı, GrowthBook exposure event'i, super
 * property); biri değişip diğerleri kalırsa aynı oturum Mixpanel'de iki farklı
 * kanal olarak görünür ve hiçbir yerde hata çıkmaz.
 */
export function clientSource(): "web" | "iscep" {
  return miniAppBridgeService.isInMiniApp() ? "iscep" : "web";
}

/**
 * `source`'u Mixpanel super property olarak yazar — yani bundan sonraki HER
 * event'e otomatik eklenir, tek tek her `track` çağrısına eklemek gerekmez.
 *
 * İki yerden çağrılmalı ve ikincisi kolayca unutulan taraf:
 *
 *  1. `mixpanel.init` sonrası (App.tsx),
 *  2. `mixpanel.reset()` her çağrıldığında (logout — Profile.tsx) ve login
 *     sonrası oturum kurulurken (establish-session.ts).
 *
 * `reset()` cookie'yi ve içindeki bütün super property'leri siliyor. Geri
 * yazılmazsa çıkıp tekrar giren kullanıcının event'leri `source`'suz gider ve
 * Mixpanel kırılımında "(undefined)" kovasına düşer — hiçbir yerde hata
 * görünmez, sadece sayılar sessizce eksilir. Deney varyantları için
 * `reRegisterExposures()` tam olarak bu yüzden var.
 *
 * Analytics asla akışı bozmaz: init edilmemiş bir Mixpanel'de `register`
 * patlayabilir, o yüzden yutuluyor.
 */
export function registerClientSource(): void {
  try {
    mixpanel.register({ source: clientSource() });
  } catch (e) {
    console.warn("Mixpanel error:", e);
  }
}
